import { Action } from '../../actions';
import {
    ACCEPT_CUSTOMER_PROJECT,
    CLOSE_DECLINE_PROJECT_POPUP,
    CLOSE_PROJECT_BY_FREELANCER,
    DECLINE_CUSTOMER_REQUEST,
    FETCH_CUSTOMERS_DATA,
    HANDLE_DECLINE_REQUEST_ERROR,
    OPEN_DECLINE_PROJECT_POPUP,
    RELEASE_DECLINE_PROJECT_POPUP,
    SHOW_CUSTOMERS_ERROR,
    UPDATE_ACTIVE_PROJECT,
    UPDATE_CUSTOMER_REQUEST,
    UPDATE_CUSTOMERS_DATA,
    UpdateActiveProjectAction,
    UpdateCustomerRequestAction
} from '../../actions/freelancers/freelancer-customers';
import { FreelancerAccessErrorTypes } from '../../service/FreelancerAccessError';
import {
    FreelancerCustomersListItem,
    FreelancerCustomersScreenStage,
    FreelancerCustomersState,
    FreelancerCustomersTabs
} from '../../typings/freelancers';
import { GdFreelancerProjectStatus } from '../../typings/graphql-grid';
import { State } from '../../typings/state';

export const initialState: FreelancerCustomersState = {
    tab: FreelancerCustomersTabs.ACTIVE,
    stage: FreelancerCustomersScreenStage.INITIAL,
    active: [],
    canceled: [],
    requested: [],
    declinePopupIsOpen: false,
    declinePopupIsDisabled: false,
    declinePopupClientId: '',
    declinePopupProjectId: ''
};

export const freelancerCustomers = (
    state: FreelancerCustomersState = initialState,
    action: Action,
    fullState: State
): FreelancerCustomersState => {
    switch (action.type) {
        case FETCH_CUSTOMERS_DATA:
            return {
                ...state,
                stage: FreelancerCustomersScreenStage.LOADING
            };
        case UPDATE_CUSTOMERS_DATA:
            const { active, canceled, requested } = action.data;

            return {
                ...state,
                active,
                canceled,
                requested,
                stage: FreelancerCustomersScreenStage.READY
            };
        case SHOW_CUSTOMERS_ERROR:
            return {
                ...state,
                stage:
                    action.errorType === FreelancerAccessErrorTypes.NO_DATA_PROVIDED
                        ? FreelancerCustomersScreenStage.ERROR
                        : FreelancerCustomersScreenStage.NO_ACCESS
            };
        case ACCEPT_CUSTOMER_PROJECT:
        case DECLINE_CUSTOMER_REQUEST:
            return {
                ...state,
                requested: state.requested.map(item => {
                    if (item.id === action.projectId) {
                        return {
                            ...item,
                            isDisabled: true
                        };
                    }

                    return item;
                })
            };
        case CLOSE_PROJECT_BY_FREELANCER:
            return {
                ...state,
                declinePopupIsDisabled: true
            };
        case UPDATE_CUSTOMER_REQUEST:
            return updateCustomerRequest(state, action);
        case UPDATE_ACTIVE_PROJECT:
            return updateActiveProject(state, action);
        case HANDLE_DECLINE_REQUEST_ERROR:
            return {
                ...state,
                requested: state.requested.map(item => {
                    if (!item.isDisabled) {
                        return item;
                    }

                    return {
                        ...item,
                        isDisabled: false
                    };
                })
            };
        case RELEASE_DECLINE_PROJECT_POPUP:
            return {
                ...state,
                declinePopupIsDisabled: false
            };
        case OPEN_DECLINE_PROJECT_POPUP:
            return {
                ...state,
                declinePopupIsOpen: true,
                declinePopupClientId: action.clientId,
                declinePopupProjectId: action.projectId
            };
        case CLOSE_DECLINE_PROJECT_POPUP:
            return {
                ...state,
                declinePopupIsOpen: false,
                declinePopupClientId: '',
                declinePopupProjectId: ''
            };
        default:
            return state;
    }
};

const updateCustomerRequest = (
    state: FreelancerCustomersState,
    action: UpdateCustomerRequestAction
): FreelancerCustomersState => {
    // текущая обработанная заявка на сотрудничество
    let deletedItem: FreelancerCustomersListItem | undefined;

    // обновленный список без обработанной заявки
    const newRequestedList = state.requested.filter(item => {
        if (item.projectId === action.projectId) {
            deletedItem = item;
        }

        return item.projectId !== action.projectId;
    });

    if (deletedItem === undefined) {
        return state;
    }

    deletedItem.updatedTime = action.updatedTime;

    // запрос на принятие заявки
    if (action.isAccepted) {
        deletedItem.status = GdFreelancerProjectStatus.IN_PROGRESS;
        deletedItem.startedTime = action.updatedTime;

        return {
            ...state,
            active: state.active.concat(deletedItem),
            requested: newRequestedList
        };

        // запрос на отклонение заявки
    } else {
        deletedItem.status = GdFreelancerProjectStatus.CANCELLED_BY_FREELANCER;

        return {
            ...state,
            canceled: state.canceled.concat(deletedItem),
            requested: newRequestedList
        };
    }
};

const updateActiveProject = (
    state: FreelancerCustomersState,
    action: UpdateActiveProjectAction
): FreelancerCustomersState => {
    // текущая обработанная заявка на сотрудничество
    let deletedItem: FreelancerCustomersListItem | undefined;

    // обновленный список без обработанной заявки
    const newActiveList = state.active.filter(item => {
        if (item.projectId === action.projectId) {
            deletedItem = item;
        }

        return item.projectId !== action.projectId;
    });

    if (deletedItem === undefined) {
        return state;
    }

    deletedItem.status = GdFreelancerProjectStatus.CANCELLED_BY_FREELANCER;

    return {
        ...state,
        canceled: state.canceled.concat(deletedItem),
        active: newActiveList,
        declinePopupIsOpen: false,
        declinePopupClientId: '',
        declinePopupProjectId: ''
    };
};
